<script setup lang="ts">
/**
 * UI-kit component
 * Category: Typography
 * Name: 'Body 1/Regular'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=216-126908&m=dev'
*/

defineOptions({
  name: 'TextPrimary',
})

withDefaults(defineProps<TextPrimaryMediumProps>(), {
  is: 'div',
})

interface TextPrimaryMediumProps {
  is?: 'div' | 'p' | 'span'
}
</script>

<template>
  <component
    :is="is"
    class="p-text-primary"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss" src="./TextPrimary.scss" />
